import { Link } from "react-router-dom";
import { Linkedin, Mail, MapPin } from "lucide-react";
import ShareButton from "@/components/ui/share-button";

const services = [
  { name: "Investment Banking & M&A", href: "/servicios/investment-banking" },
  { name: "Corporate Finance & FP&A", href: "/servicios/corporate-finance" },
  { name: "CFO as a Service", href: "/servicios/cfo-as-a-service" },
  { name: "Vinculación de Capital o Deuda", href: "/servicios/capital-y-deuda" },
];

const empresa = [
  { name: "Quiénes somos", href: "#nosotros" },
  { name: "Equipo", href: "#equipo" },
  { name: "Nuestros Clientes", href: "#nuestros-clientes" },
  { name: "Insights", href: "/insights" },
  { name: "Contacto", href: "/contacto" },
];

export default function Footer() {
  return (
    <footer className="bg-navy-deep text-bone">
      <div className="container mx-auto px-4 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div>
            <span className="font-display text-3xl font-bold tracking-wider block mb-1">SYCMA</span>
            <div className="w-16 h-px bg-gold mb-2" />
            <span className="font-display text-xs tracking-[0.3em] uppercase text-steel block mb-4">Corporate Finance</span>
            <p className="text-steel text-sm mb-6 max-w-xs">
              Investment Banking & M&A Advisory para el mundo hispanohablante.
            </p>
            <div className="space-y-3 text-sm text-steel">
              <a href="mailto:comercial@sycmahg.com" className="flex items-center gap-2 hover:text-gold transition-colors">
                <Mail className="h-4 w-4" />
                comercial@sycmahg.com
              </a>
              <a
                href="https://www.linkedin.com/company/sycma-holding-group/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-gold transition-colors"
              >
                <Linkedin className="h-4 w-4" />
                LinkedIn SYCMA
              </a>
              <div className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <span>Miami · Madrid · México · Colombia · Argentina</span>
              </div>
            </div>
          </div>

          {/* Servicios */}
          <div>
            <h4 className="font-display font-semibold text-bone mb-4 text-sm">Servicios</h4>
            <ul className="space-y-2">
              {services.map((s) => (
                <li key={s.name}>
                  <Link to={s.href} className="text-sm text-steel hover:text-gold transition-colors">
                    {s.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Empresa */}
          <div>
            <h4 className="font-display font-semibold text-bone mb-4 text-sm">Empresa</h4>
            <ul className="space-y-2">
              {empresa.map((item) => (
                <li key={item.name}>
                  {item.href.startsWith("/") ? (
                    <Link to={item.href} className="text-sm text-steel hover:text-gold transition-colors">
                      {item.name}
                    </Link>
                  ) : (
                    <a href={item.href} className="text-sm text-steel hover:text-gold transition-colors">
                      {item.name}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-border/30">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-3">
              <p className="text-xs text-steel text-center md:text-left">
                © {new Date().getFullYear()} SYCMA Corporate Finance. Todos los derechos reservados.
              </p>
              <ShareButton variant="icon" className="text-steel hover:text-gold" />
            </div>
            <div className="flex items-center gap-6">
              <Link to="/privacidad" className="text-xs text-steel hover:text-gold transition-colors">
                Política de Privacidad
              </Link>
              <Link to="/terminos" className="text-xs text-steel hover:text-gold transition-colors">
                Términos y Condiciones
              </Link>
              <Link to="/datos" className="text-xs text-steel hover:text-gold transition-colors">
                Tratamiento de Datos
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
